export default {"src":"/_next/static/media/0x50b728d8d964fd00c2d0aad81718b71311fef68a.a00108f4.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};